import { stackClientApp } from '../stackClient';

export async function getNeonAccessTokenOrRedirect() {
  const user = await stackClientApp.getUser();

  if (!user) {
    // Not logged in -> send to login page
    window.location.href = '/login';
    throw new Error('Not authenticated');
  }

  const authJson = await user.getAuthJson();
  const accessToken = authJson.accessToken;

  return { user, accessToken };
}
